
import Vue from 'vue';
import Router from 'vue-router';
import { storage } from 'BASE/common/util/util.storage'; 

const Layout = () => import('LS/views/Layout.vue');
const Login = () => import('LS/views/Login/Login.vue');
const ChatAnonymity = () => import('LS/views/ChatAnonymity/ChatAnonymity.vue');
const Home = () => import('LS/views/Home/Home.vue');
const DownLoadCenterAndAFK = () => import('LS/views/DownloadCenter/DownLoadCenterAndAFK.vue');
const Timeout = () => import('LS/views/ErrorHandle/Timeout.vue');
const Offline = () => import('LS/views/ErrorHandle/Offline.vue');
const ErrorMsg = () => import('LS/views/ErrorHandle/ErrorMsg.vue');
const IPRestricted = () => import('LS/views/ErrorHandle/IPRestricted.vue');
const LinkFailure = () => import('LS/views/Register/Register.LinkFailure.vue');
const Register = () => import('LS/views/Register/Register.vue');   
const Bet = () => import('LS/views/Bet/Bet.vue');
const ComboBet = () => import('LS/views/ComboBet/ComboBet.vue');
const DrawHistory = () => import('LS/views/DrawHistory/DrawHistory.vue');
const AccountInfo = () => import('LS/views/AccountCenter/AccountInfo.vue');
const Player = () => import('LS/views/Player/Player.vue');
const DailyPayManagement = () => import('LS/views/DailyPay/DailyPayManagement.vue');
const DailyPayManagementCG = () => import('LS/views/DailyPayCG/DailyPayManagement.vue');
const DailyRebateManagement = () => import('LS/views/DailyRebate/DailyRebateManagement.vue');
const MyDailyPay = () => import('LS/views/DailyPay/MyDailyPay.vue');
const MyDailyPayCG = () => import('LS/views/DailyPayCG/MyDailyPay.vue');
const MyDailyRebate = () => import('LS/views/DailyRebate/MyDailyRebate.vue');
const CreatePlayer = () => import('LS/views/Player/Player.Create.vue');
const RegisterLink = () => import('LS/views/RegisterLink/RegisterLink.vue');
const TradeAgreement = () => import('LS/views/TradeAgreement/TradeAgreement.vue');
const TradeAgreementCurrency = () => import('LS/views/TradeAgreement/TradeAgreement.Currency.vue');
const ExternalGameTrans = () => import('LS/views/ExternalGameTrans/ExternalGameTrans.vue');
const ExternalGameCardSubItem = () => import('LS/views/ExternalGame/ExternalGameCardSubItem.vue');
const ExternalGameFishSubItem = () => import('LS/views/ExternalGame/ExternalGameFishSubItem.vue');
const ExternalGameVideoLobby = () => import('LS/views/ExternalGame/ExternalGameVideoLobby.vue');
const ExternalGameSlotSubItem = () => import('LS/views/ExternalGame/ExternalGameSlotSubItem.vue');
const ExternalGameSportLobby = () => import('LS/views/ExternalGame/ExternalGameSportLobby.vue');
const ExternalGameFishLobby = () => import('LS/views/ExternalGame/ExternalGameFishLobby.vue');
const ExternalGameBlockchain = () => import('LS/views/ExternalGame/ExternalGameBlockchain.vue');
const WithdrawRequest = () => import('LS/views/WithdrawRequest/WithdrawRequest.vue');
const WithdrawRecord = () => import('LS/views/WithdrawRecord/WithdrawRecord.vue');
const ExternalGameTransRecord = () => import('LS/views/ExternalGameTransRecord/ExternalGameTransRecord.vue');
const BetRecord = () => import('LS/views/BetRecord/BetRecord.vue');
const ScheduleRecord = () => import('LS/views/ScheduleRecord/ScheduleRecord.vue');
const CashFlowRecord = () => import('LS/views/CashFlowRecord/CashFlowRecord.vue');
const ActiveAccount = () => import('LS/views/ActiveAccount/ActiveAccount.vue');
const AccountSecurity = () => import('LS/views/AccountCenter/AccountSecurity.vue');
const AccountPassword = () => import('LS/views/AccountCenter/AccountPassword.vue');
const DrawLobby = () => import('LS/views/DrawLobby/DrawLobby.vue');
const ProfitReport = () => import('LS/views/ProfitReport/ProfitReport.Main.vue');
const Deposit = () => import('LS/views/Deposit/Deposit.vue');
const DepositQrcode = () => import('LS/views/Deposit/DepositQrcode.vue');
const DepositRecord = () => import('LS/views/DepositRecord/DepositRecord.vue');
const AwardDetail = () => import('LS/views/AwardDetail/AwardDetail.vue');
const Activity = () => import('LS/views/Activity/Activity.vue');
const OneDollarActivity = () => import('LS/views/Activity/OneDollarActivity.vue');
const DailyInterestActivity = () => import('LS/views/Activity/DailyInterest.vue');
const Coupon = () => import('LS/views/Coupon/Coupon.vue');
const FirstDepositByCategoryActivity = () => import('LS/views/Activity/FirstDepositByCategoryActivity.vue');
const DepositConsumeKENO2Activity = () => import('LS/views/Activity/DepositConsumeKENO2Activity.vue');
const DailySigninRedPackActivity = () => import('LS/views/Activity/DailySigninRedPackActivity.vue');
const RouletteActivity = () => import('LS/views/Activity/RouletteActivity.vue');
const NewbieQuestActivity = () => import('LS/views/Activity/NewbieQuestActivity.vue');
const RedPacketSolitaire = () => import('LS/views/Activity/RedPacketSolitaire.vue');
const LionKingContest = () => import('LS/views/Activity/LionKingContest.vue');
const BonusWallet = () => import('LS/views/AccountCenter/BonusWallet.vue');
const BlockChainHash = () => import('LS/views/BlockChainHash/BlockChainHash.vue');
const IFrame = () => import('LS/views/IFrame.vue');

Vue.use(Router);

Router.prototype.refreshTo = function (path) {
    window.location.href = path;
};

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        { path: '/Login', name: 'Login', component: Login, meta: { ignoreAuth: true } },
        { path: '/ChatAnonymity', name: 'ChatAnonymity', component: ChatAnonymity, meta: { ignoreAuth: true } },
        { path: '/Timeout', component: Timeout, meta: { ignoreAuth: true } },
        { path: '/Offline', component: Offline, meta: { ignoreAuth: true } },
        { path: '/LinkFailure', component: LinkFailure, meta: { ignoreAuth: true } },
        { path: '/ErrorMsg', name: 'ErrorMsg', component: ErrorMsg, meta: { ignoreAuth: true } },
        { path: '/IPRestricted', name: 'IPRestricted', component: IPRestricted, meta: { ignoreAuth: true } },
        { path: '/Register/:code', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        { path: '/Register', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        { path: '/DrawHistory/:id', name: 'DrawHistory', component: DrawHistory, meta: { ignoreAuth: true } },
        { path: '/DepositQrcode', name: 'DepositQrcode', component: DepositQrcode},
        //以上是忽略驗證是否有登入，需登入後才顯得ignoreAuth請不要設置

        //以下是登入後須套用header、footer、chat的頁面
        {
            path: '/', component: Layout,
            children: [
                { path: '/', name: 'Home', component: Home },
                { path: '/Bet/:id', name: 'Bet', component: Bet },
                { path: '/ComboBet', name: 'ComboBet', component: ComboBet },
                { path: '/DownLoadCenterAndAFK', name: 'DownLoadCenterAndAFK', component: DownLoadCenterAndAFK },
                { path: '/AccountInfo', name: 'AccountInfo', component: AccountInfo },
                { path: '/Player', component: Player, meta: { isAgentAllow: true } },
                { path: '/DailyPayManagement', component: DailyPayManagement, meta: { isAgentAllow: true } },
                { path: '/DailyPayManagementCG', component: DailyPayManagementCG, meta: { isAgentAllow: true } },
                { path: '/DailyRebateManagement', component: DailyRebateManagement, meta: { isAgentAllow: true } },
                { path: '/MyDailyPay', component: MyDailyPay },
                { path: '/MyDailyPayCG', component: MyDailyPayCG },
                { path: '/MyDailyRebate', component: MyDailyRebate },
                { path: '/CreatePlayer', component: CreatePlayer, meta: { isAgentAllow: true }},
                { path: '/RegisterLink', component: RegisterLink, meta: { isAgentAllow: true }},
                { path: '/AwardDetail', name: 'AwardDetail', component: AwardDetail },
                { path: '/TradeAgreement', component: TradeAgreement },
                { path: '/TradeAgreementCurrency', component: TradeAgreementCurrency },
                { path: '/ExternalGameTrans', name: 'ExternalGameTrans', component: ExternalGameTrans },

                { path: '/ExternalGameCardSubItem/:gameType', name: 'ExternalGameCardSubItem', component: ExternalGameCardSubItem },
                { path: '/ExternalGameFishSubItem/:gameType', name: 'ExternalGameFishSubItem', component: ExternalGameFishSubItem },
                { path: '/ExternalGameVideoLobby/', name: 'ExternalGameVideoLobby', component: ExternalGameVideoLobby },
                { path: '/ExternalGameSlotSubItem/:gameType', name: 'ExternalGameSlotSubItem', component: ExternalGameSlotSubItem },
                { path: '/ExternalGameSportLobby/', name: 'ExternalGameSportLobby', component: ExternalGameSportLobby },
                { path: '/ExternalGameFishLobby/', name: 'ExternalGameFishLobby', component: ExternalGameFishLobby },
                { path: '/ExternalGameBlockchain/', name: 'ExternalGameBlockchain', component: ExternalGameBlockchain },
                { path: '/WithdrawRequest', name: 'WithdrawRequest', component: WithdrawRequest },
                { path: '/WithdrawRecord', name: 'WithdrawRecord', component: WithdrawRecord },

                { path: '/AccountSecurity', name: 'AccountSecurity', component: AccountSecurity },
                { path: '/AccountPassword', name: 'AccountPassword', component: AccountPassword },
                { path: '/BonusWallet', name: 'BonusWallet', component: BonusWallet },
                { path: '/ExternalGameTransRecord', name: 'ExternalGameTransRecord', component: ExternalGameTransRecord },
                { path: '/BetRecord', name: 'BetRecord', component: BetRecord },
                { path: '/ScheduleRecord', name: 'ScheduleRecord', component: ScheduleRecord },
                { path: '/CashFlowRecord', name: 'CashFlowRecord', component: CashFlowRecord },
                { path: '/ActiveAccount', name: 'ActiveAccount', component: ActiveAccount, meta: { isAgentAllow: true } },
                { path: '/DrawLobby', name: 'DrawLobby', component: DrawLobby },
                { path: '/ProfitReport', name: 'ProfitReport', component: ProfitReport },
                { path: '/Deposit', name: 'Deposit', component: Deposit },
                { path: '/DepositRecord', name: 'DepositRecord', component: DepositRecord },
                { path: '/Activity', name: 'Activity', component: Activity },
                { path: '/OneDollarActivity', name: 'OneDollarActivity', component: OneDollarActivity },
                { path: '/DailyInterestActivity', name: 'DailyInterestActivity', component: DailyInterestActivity },
                { path: '/Coupon', name: 'Coupon', component: Coupon },
                { path: '/FirstDepositByCategoryActivity', name: 'FirstDepositByCategoryActivity', component: FirstDepositByCategoryActivity },
                { path: '/DepositConsumeKENO2Activity/:id', name: 'DepositConsumeKENO2Activity', component: DepositConsumeKENO2Activity },
                { path: '/DailySigninRedPackActivity', name: 'DailySigninRedPackActivity', component: DailySigninRedPackActivity },
                { path: '/RouletteActivity', name: 'RouletteActivity', component: RouletteActivity },
                { path: '/NewbieQuestActivity', name: 'NewbieQuestActivity', component: NewbieQuestActivity },
                { path: '/RedPacketSolitaire', name: 'RedPacketSolitaire', component: RedPacketSolitaire },
                { path: '/LionKingContest', name: 'LionKingContest', component: LionKingContest },
                { path: '/BlockChainHash', name: 'BlockChainHash', component: BlockChainHash },
                { path: '/IFrame', name: 'IFrame', component: IFrame },
            ]
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.name == "Login") {
        //透過window.location.href跳回Login遇載app.vue時會是之前的權限需將token先砍掉
        storage.local.remove(storage.keys.ACCESS_TOKEN);
    }

    if (to.matched.some(record => record.meta.ignoreAuth)) {
        next();
    } else {
        let isAgent = storage.local.get(storage.keys.ISAGENT);
        if (to.matched.some(record => record.meta.isAgentAllow) && !isAgent) {
            //若登入帳號不是Agent，則回到首頁
            next('/');
        }

        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            next();
        }
        else if (to.name === "Home" && from.fullPath === to.fullPath) {
            //如平台沒有未登入首頁時須設定該部分，當玩家直接透過網址做網頁跳轉時如沒token需直接跳到登入
            router.refreshTo('/Login');
        }
        else {
            next('/Timeout');   // 認證已過期
        }
    }
});

// 投注一般、旗艦版導向
router.afterEach(to => {
    if (to.meta.betClientTemplate) {
        storage.local.set(storage.keys.BET_CLIENT_TEMPLATE, to.meta.betClientTemplate);
    }
});

export default router;
